import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "작성일"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    conditions.push(...SearchColumnKeyword.methods.getConditions(nav, "column", heads));
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "사업장명",
        key: "body.사업장.field_name",
      },
      {
        name: "팀명",
        key: "body.팀명",
      },
      {
        name: "공장명",
        key: "body.공장명",
      },
      {
        name: "공정명",
        key: "body.공정명",
      },
      {
        name: "상태",
        key: "body.상태",
      },
      {
        name: "활동명",
        key: "body.활동명",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 1:
          return func.getContent(value).팀명; // 점검일
        case 2:
          return func.getContent(value).공장명; // 공장명
        case 3:
          return func.getContent(value).공정명; // 공정명
        case 4:
          return func.getContent(value).상태; // 상태
        case 5:
          return func.getContent(value).활동명; // 활동명
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
